import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { addUpload } from '@pingum/app-state-management/event/actions';
import {
  Button,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormLabel,
  TextField,
} from '@mui/material';
import FileUpload from './FileUpload';

const isNameValid = (name) => (
  name === null
  || name === undefined
  || name === ''
  || (name.length >= 2
  && name.length <= 150)
);

const getDefaultState = () => ({
  displayName: '',
  file: null,
  validation: {
    displayName: {
      isValid: true,
      message: '',
    },
    file: { isValid: true },
  },
}
);

export class AttachFileModalComponent extends React.Component {
  constructor(props) {
    super(props);

    // this.fileUploadRef = React.createRef();

    this.state = getDefaultState();
  }

  handleDisplayNameChange = (e) => {
    const displayName = e.target.value;
    const isValid = isNameValid(displayName);

    this.setState((prevState) => ({
      displayName,
      validation: {
        ...prevState.validation,
        displayName: {
          isValid,
          message: !isValid
            ? <span><br />Display name must be between 2 and 150 characters in length or empty</span>
            : '',
        },
      },
    }));
  }

  handleCloseModal = () => {
    this.setState(getDefaultState());
    this.props.handleCloseModal();
  }

  addUpload = () => {
    if (this.isValid()) {
      let checkedDisplayName = this.state.displayName;
      if (checkedDisplayName <= 0) {
        checkedDisplayName = this.state.file.name;
      }
      this.props.addUpload(this.props.eventId, checkedDisplayName, this.state.file);
      this.setState(getDefaultState());
      this.props.handleCloseModal();
    }
  }

  handleFileChange = (file) => {
    this.setState({ file });
  }

  handleFileCancel = () => {
    this.setState({ file: null });
  }

  isValid = () => {
    if (isNameValid(this.state.displayName) && this.state.file) {
      return true;
    }
    return false;
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.props.isOpen}
          fullScreen={this.props.fullScreen}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Attach a File</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Drop or find a file to attached to this task
            </DialogContentText>
            <TextField
              sx={{ mt: 2 }}
              id="file-display-name"
              fullWidth
              label="File Display Name"
              autoFocus
              onChange={this.handleDisplayNameChange}
              variant="outlined"
              helperText={!this.state.validation.displayName.isValid
                ? this.state.validation.displayName.message
                : '(optional)'}
              error={!this.state.validation.displayName.isValid}
            />
            <FormControl
              error={!this.state.validation.file.isValid}
              margin="normal"
              fullWidth
              aria-describedby="file-upload"
            >
              <FormLabel>
                File
              </FormLabel>
              <FileUpload
                onChange={this.handleFileChange}
                onCancel={this.handleFileCancel}
              />

            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleCloseModal}
            >
              Cancel
            </Button>
            <Button
              onClick={this.addUpload}
              color="primary"
              disabled={!this.isValid()}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

AttachFileModalComponent.propTypes = {
  isOpen: PropTypes.bool,
  handleCloseModal: PropTypes.func,
  addUpload: PropTypes.func,
  eventId: PropTypes.number,
  fullScreen: PropTypes.bool,
};

AttachFileModalComponent.defaultProps = {
  isOpen: false,
  handleCloseModal: () => {},
  addUpload: () => {},
  eventId: -1,
  fullScreen: false,
};

export const mapDispatchToProps
  = (dispatch) => ({ addUpload: (id, displayName, file) => dispatch(addUpload(id, displayName, file)) });

export default connect(
  null,
  mapDispatchToProps,
)((AttachFileModalComponent));
